module.exports = __webpack_public_path__ + "static/img/point_icon_08.1f310f29.svg";